import { Link } from "react-router-dom";
import { useTheme } from "@mui/styles";
import React from "react";
import styled from "styled-components";

import {SHOPIFY_URL} from "../../utils/shopify.utils";
import { useTranslation } from "react-i18next";
import ContainedButton from "../../components/Buttons/ContainedButton";
import onePercentSrc from "../../assets/images/1%.png";
import {
  Paragraph,
  SlideContainer,
  Title,
} from "./OurCommitment.styles";


const StyledTitle = styled(Title)`
  width: 100%;
  font-weight: 500;
  font-size: 26px;
`;

const OutCommitmentSlide4 = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <SlideContainer style={{padding:"0px 20px"}}>
      <OnePercent />
      <StyledTitle theme={theme}>
        {t(
          "Of The Profits From Every evrbed Sold Will Go Directly To Our Innovation Fund"
        )}
      </StyledTitle>
      <Paragraph theme={theme}>
        {t(
          "Our innovation fund sponsors initiatives with sustainable mattress designs and new recycling technologies."
        )}
      </Paragraph>
      <Paragraph theme={theme}>
        {t("Learn more about what we are up to.")}
      </Paragraph>
      <LearnMore />
    </SlideContainer>
  );
};

const OnePercent = styled.img.attrs({
  src: onePercentSrc,
})`
width: 105px;
`;

const StyledContainedButton = styled(ContainedButton)`
  margin-top: 40px;
  padding-right: 1rem;
`;

const LearnMore = () => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Link to={"/learn-more"}>
      <StyledContainedButton
        color={theme.COLORS.GREEN.green}
        fontColor={theme.COLORS.GREEN.lightGreen}
        variant={"contained"}
        onClick={() => {
          return (window.top.location.href =
                SHOPIFY_URL + "pages/shipping-delivery2");
        }}
        styles={{
          fontSize: "12px",
          height: "41px",
          fontWeight: "600",
        }}
      >
        {t("Learn More")}
      </StyledContainedButton>
    </Link>
  );
};

export default OutCommitmentSlide4;
